(function() {
    window.CRISP_READY_TRIGGER = function() {
        $crisp.push(["safe", true]);
    };
}());

jQuery(document).ready(function($) {
    'use strict';

    $(document.body).on('click', '.open-crisp-chat', function(e) {
        e.preventDefault();

        if (window.$crisp) {
            window.$crisp.push(['do', 'chat:open']);
        }
    });
});
